import type { SidesResponse } from './interfaces'
import { ErrorResponse } from '@library/http/src/parsers/errors'

export async function extractSidesResponse(response: Response): Promise<SidesResponse> {
  if (!response.ok) {
    throw new ErrorResponse(response)
  }

  return response.json()
}
